import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";

export default function isNepNumber(str, responseText) {
    const regVal = regexList.nepNumber.pattern;
    return regexTest(str, regVal, responseText) || regexList.engNumber.response;
}